import { GetterTree } from 'vuex'
import { INavigationState } from './types'

const getters: GetterTree<INavigationState, any> = {
    isSecondLevelOpen(state): boolean {
        return state.secondLevelIsOpen
    },
    isEventsPanelOpen(state): boolean {
        return state.eventsPanelIsOpen
    },
    activeTopLevelIndex(state): number | null {
        return state.activeTopLevelIndex
    },
    activeSecondLevelIndex(state): number | string | null {
        return state.activeSecondLevelIndex
    },
    navData(state): any {
        return state.navData
    },
    eventsData(state): any {
        return state.eventsData
    },
}

export default getters

